import { Affix, Button, Card, Form } from "antd";
import { isMobileView } from "components/Common/AppHelper";
import Header from "components/Common/Header";
import { useNavigate } from "react-router-dom";
import MarinaCoverNoteBillForm from "../SubmitForm";

const AddMarinaCoverNoteBill = (props) => {
  const { width } = props;
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const discardForm = () => {
    navigate("/import-export-expense-tracking/marine-cover-note-bill");
  };

  const addNewMarinaCoverNoteBill = () => {
    form.submit();
  };

  return (
    <>
      <Affix offsetTop={0}>
        <Card className="p-fixed" style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}>
          <Header
            title="Add New Marine Cover Note Bill"
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={[
              <Button size="small" key={1} danger onClick={() => discardForm()}>
                Discard
              </Button>,
              <Button size="small" key={2} type="primary" onClick={() => addNewMarinaCoverNoteBill()}>
                Issue Bill
              </Button>,
            ]}
          />
        </Card>
      </Affix>

      <MarinaCoverNoteBillForm form={form} isCreate={true} />
    </>
  );
};

export default AddMarinaCoverNoteBill;
